<script lang="ts">
	interface Props {
		name: string
		first: string
		firstActiveClass?: string
		second: string
		secondActiveClass?: string
		checked: boolean
		checkedClass?: string
		uncheckedClass?: string
		onChange?: (value: boolean) => void
	}

	let {
		name,
		first,
		firstActiveClass = 'text-green-400',
		second,
		secondActiveClass = 'text-green-400',
		checked = $bindable(),
		checkedClass = 'bg-green-400',
		uncheckedClass = 'bg-green-400',
		onChange = null,
	}: Props = $props()

	function handleChange() {
		onChange?.(checked)
	}
</script>

<div class="flex">
	<label class="inline-flex cursor-pointer items-center space-x-2.5" for={name}>
		<div class={!checked ? firstActiveClass : ''}>
			{first}
		</div>

		<div class="relative">
			<input
				id={name}
				class="peer pointer-events-none absolute opacity-0"
				onchange={handleChange}
				type="checkbox"
				bind:checked
			/>

			<div
				class="relative flex h-5 w-15 items-center rounded-md border border-gray-200 px-1 outline-blue-700 peer-focus:outline-2 dark:border-gray-500"
			>
				<div
					class="h-3 w-6 rounded transition-transform {checked
						? checkedClass
						: uncheckedClass} {checked ? 'translate-x-6' : ''}"
				></div>
			</div>
		</div>

		<div class={checked ? secondActiveClass : ''}>
			{second}
		</div>
	</label>
</div>
